module.exports = __webpack_public_path__ + "img/project_memory.bf22eccc.png";